import { api } from '../../api'

export const taxRatesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    createTaxRates: builder.mutation({
      invalidatesTags: ['organizationCards'],
      query: ({ organizationBody }) => {
        return {
          url: `/tax-rates`,
          method: 'POST',
          body: organizationBody,
        }
      },
    }),
    updateTaxRates: builder.mutation({
      invalidatesTags: ['organizationCards'],
      query: ({ organizationCardId, organizationBody }) => {
        return {
          url: `/tax-rates/${organizationCardId}`,
          method: 'PATCH',
          body: organizationBody,
        }
      },
    }),
    deleteTaxRates: builder.mutation({
      invalidatesTags: ['organizationCards'],
      query: ({ taxRateId }) => {
        return {
          url: `/tax-rates/${taxRateId}`,
          method: 'DELETE',
        }
      },
    }),
  }),
})

export const {
  useCreateTaxRatesMutation,
  useUpdateTaxRatesMutation,
  useDeleteTaxRatesMutation,
} = taxRatesApi
